import './MobileStyle2.scss';

const MobileStyle2 = ({ children }: { children: JSX.Element }) => {
  return children;
};

export default MobileStyle2;
